module.exports = __webpack_public_path__ + "static/media/LTadmin.197f2d72.svg";